export default __webpack_public_path__ + "static/media/ChantzNew.e998dcf7.jpeg";